import { Controller, FieldValues, Path, PathValue, useFormContext } from "react-hook-form";
import { UploadButtonForm } from "./UploadButtonForm";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField } from "@mui/material";
import { IRow } from "../types";
import { ReactNode } from "react";

interface IProps {
    bodyCell: Array<IRow>;
    headerCell?: Array<string>;
    header?: ReactNode;
}

export const ReportTableCreator = <T extends FieldValues>({ headerCell, bodyCell, header }: IProps) => {
    const { control } = useFormContext<T>();
    return (
        <TableContainer>
            <Table sx={{ "& td": { border: "none" } }}>
                <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 700 } }}>
                    {header ? (
                        header
                    ) : (
                        <TableRow>
                            {headerCell?.map((cell, index) => (
                                <TableCell sx={{ whiteSpace: "pre-wrap" }} key={index}>
                                    {cell}
                                </TableCell>
                            ))}
                        </TableRow>
                    )}
                </TableHead>
                <TableBody>
                    {bodyCell.map((row, index) => (
                        <TableRow key={index} sx={{ border: 0 }}>
                            {Object.values(row).map((cell, index) => (
                                <TableCell key={index} sx={{ whiteSpace: "pre-wrap" }}>
                                    {typeof cell === "string" ? (
                                        cell
                                    ) : (
                                        <Controller
                                            defaultValue={"" as PathValue<T, Path<T>>}
                                            name={cell.name as Path<T>}
                                            control={control}
                                            rules={{
                                                maxLength: {
                                                    value: 120,
                                                    message: "Максимальная длина 120 символов",
                                                },
                                            }}
                                            render={({ field: { onChange, value, ...field }, fieldState }) => {
                                                return (
                                                    <>
                                                        <TextField
                                                            {...field}
                                                            onChange={e => {
                                                                if (cell.fileList) {
                                                                    onChange(e.target.value.split("\n"));
                                                                } else if (cell.numeric) {
                                                                    const inputValue = e.target.value;

                                                                    // Регулярное выражение для валидации:
                                                                    // ^          - начало строки
                                                                    // \d*        - ноль или более цифр
                                                                    // (          - начало необязательной группы
                                                                    //   \.       - точка
                                                                    //   \d{0,2}  - ноль, одна или две цифры
                                                                    // )?         - конец необязательной группы (точка и цифры могут отсутствовать)
                                                                    // $          - конец строки
                                                                    const regex = /^\d*(\.\d{0,2})?$/;

                                                                    if (inputValue === "" || regex.test(inputValue)) {
                                                                        onChange(inputValue);
                                                                    }
                                                                } else {
                                                                    onChange(e.target.value);
                                                                }
                                                            }}
                                                            value={
                                                                cell.fileList
                                                                    ? (Array.isArray(value) ? value : [value]).join(
                                                                          "\n",
                                                                      )
                                                                    : value
                                                            }
                                                            multiline={!!cell.fileList}
                                                            sx={{
                                                                minWidth: cell.fileList ? "200px" : "initial",
                                                            }}
                                                            size={"small"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            fullWidth
                                                            error={!!fieldState.error}
                                                            helperText={
                                                                fieldState.error?.message ??
                                                                (cell.fileList &&
                                                                    "Введите ссылки на файлы через Enter или загрузите документ")
                                                            }
                                                        />
                                                        {cell.fileList && (
                                                            <>
                                                                <UploadButtonForm
                                                                    onChange={val => onChange([...value, val])}
                                                                />
                                                            </>
                                                        )}
                                                    </>
                                                );
                                            }}
                                        />
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
